import PackagesAPI from 'shipping/api/packages';

const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

const getters = {
  getPackages: s => s.records,
  getUIFlags: s => s.uiFlags,
};

const mutations = {
  SET_UI_FLAG(s, data) {
    s.uiFlags = { ...s.uiFlags, ...data };
  },
  SET_PACKAGES(s, records) {
    s.records = records;
  },
  ADD_PACKAGE(s, record) {
    let records = [...s.records, record];
    if (record.is_default) {
      records = records.map(r =>
        r.id === record.id ? r : { ...r, is_default: false }
      );
    }
    s.records = records.sort((a, b) => {
      if (b.is_default !== a.is_default) return b.is_default ? 1 : -1;
      return a.name.localeCompare(b.name);
    });
  },
  EDIT_PACKAGE(s, record) {
    s.records = s.records.map(r => {
      if (r.id === record.id) return record;
      if (record.is_default) return { ...r, is_default: false };
      return r;
    });
  },
  DELETE_PACKAGE(s, id) {
    s.records = s.records.filter(r => r.id !== id);
  },
};

const actions = {
  async get({ commit }) {
    commit('SET_UI_FLAG', { isFetching: true });
    try {
      const response = await PackagesAPI.get();
      commit('SET_PACKAGES', response.data);
    } finally {
      commit('SET_UI_FLAG', { isFetching: false });
    }
  },

  async create({ commit }, data) {
    commit('SET_UI_FLAG', { isCreating: true });
    try {
      const response = await PackagesAPI.create(data);
      commit('ADD_PACKAGE', response.data);
      return response.data;
    } finally {
      commit('SET_UI_FLAG', { isCreating: false });
    }
  },

  async update({ commit }, { id, ...data }) {
    commit('SET_UI_FLAG', { isUpdating: true });
    try {
      const response = await PackagesAPI.update(id, data);
      commit('EDIT_PACKAGE', response.data);
      return response.data;
    } finally {
      commit('SET_UI_FLAG', { isUpdating: false });
    }
  },

  async delete({ commit }, id) {
    commit('SET_UI_FLAG', { isDeleting: true });
    try {
      await PackagesAPI.delete(id);
      commit('DELETE_PACKAGE', id);
    } finally {
      commit('SET_UI_FLAG', { isDeleting: false });
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
